import { debug } from "debug";

const log = debug("fontface:setupFontFace");

// CUSTOMIZED: added ext parameter, so the caller can specify it explicitly, in case the URL doesn't end with the extension, e.g x.woff?sha=d2b21158e86fa982

/**
 * Guess the font's CSS "format" by analysing the asset path.
 */
function getFontCSSFormat(path, errorOnStyle, ext = null) {
  if (ext === null) {
    let pos = path.lastIndexOf(`.`);
    ext = (path.substring(pos + 1) || ``).toLowerCase();
  }

  let format = {
    ttf: `truetype`,
    otf: `opentype`,
    woff: `woff`,
    woff2: `woff2`,
  }[ext];

  if (format) return format;

  let msg = {
    eot: `The .eot format is not supported: it died in January 12, 2016, when Microsoft retired all versions of IE that didn't already support WOFF.`,
    svg: `The .svg format is not supported: SVG fonts (not to be confused with OpenType with embedded SVG) were so bad we took the entire fonts chapter out of the SVG specification again.`,
    fon: `The .fon format is not supported: this is an ancient Windows bitmap font format.`,
    ttc: `Based on the current CSS specification, font collections are not (yet?) supported.`,
  }[ext];

  if (!msg) msg = `${path} is not a known webfont format.`;

  if (errorOnStyle) {
    // hard stop if the user wants stylesheet errors to count as true errors,
    throw new Error(msg);
  } else {
    // otherwise, only leave a warning in the output log.
    console.warn(`Could not load font: ${msg}`);
  }
}

/**
 * Create an @font-face stylesheet for browser use.
 */
async function setupFontFace(name, url, options = {}) {
  if (!globalThis.document) return;

  let format = getFontCSSFormat(url, options.errorOnStyle, options.ext);
  if (!format) return;

  let style = document.getElementById(`font-face-style`);
  if (!style) {
    style = document.createElement(`style`);
    style.id = `font-face-style`;
    style.className = `injected-by-Font-js`;
    style.textContent = `/* added in setupFontFace */\n`;
  }

  let rules = [];
  if (options.styleRules) {
    rules = Object.entries(options.styleRules).map(
      ([key, value]) => `${key}: ${value};`
    );
  }

  log(`injecting a @font-face rule: ${name}, ${format}`);

  style.textContent += `
@font-face {
    font-family: "${name}";
    ${rules.join(`\n\t`)}
    src: url("${url}") format("${format}");
}`;
  globalThis.document.head.appendChild(style);
  return style;
}

export { setupFontFace };
